import React, { useEffect, useState } from 'react'
import CustomInput from '../CustomInput'
import CustomSelect from '../CustomSelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { InitialDriverInterface } from '../../types/driver-type';
import { providerPermissionFields } from '../providerComponents/providersData';
import { InsuranceProviderInterface } from '../../types/provider-types';
import { useDebounceCallback } from 'usehooks-ts';

interface TDriverForm {
    item: InitialDriverInterface;
    RemoveDriver: (rId: string) => void;
    providerDetails?: InsuranceProviderInterface
    fetchDrivers: (driversData: {}) => void;
}

const DriverForm: React.FC<TDriverForm> = ({ item, RemoveDriver, providerDetails, fetchDrivers }) => {
    const [driver, setDriver] = useState<Record<string, any>>({ rId: item?.rId, chaseType: item?.chaseType })
    const [driverchaseItems, setDriverChaseItems] = useState<typeof providerPermissionFields>([]);

    // ---------------------------------- [ UPDATE INPUT VALUES ] --------------------------------

    const HandleChangeDriverValues = useDebounceCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setDriver((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }, 200)

    // --------------------------------- [ SET DEFALT DRIVER CHASES ] ------------------------------

    useEffect(() => {
        const setDefaultDriverChase = (): typeof providerPermissionFields => {
            return providerDetails?.id ? providerPermissionFields.filter((provField) => providerDetails[provField.id] === "Additional Driver") : []
        }
        setDriverChaseItems(setDefaultDriverChase())
    }, [providerDetails])


    // ---------------------------------- [ SEND DATA TO PARENTER ] ---------------------------------
    useEffect(() => {
        const driverData = { ...driver, chaseItems: driverchaseItems }
        fetchDrivers(driverData)
    }, [driver, driverchaseItems]) // eslint-disable-line

    return (
        <div className="bg-surface-muted border border-edge-faint rounded-xl p-5 smallTablet:p-4">
            <div className="flex items-center justify-between gap-4">
                <p className="text-[13px] font-semibold text-text-primary">Additional driver</p>
                <button
                    type="button"
                    title="Remove driver"
                    onClick={() => RemoveDriver(item?.rId)}
                    className="h-8 w-8 rounded-lg flex items-center justify-center text-light-gray hover:text-rose-600 dark:hover:text-rose-300 hover:bg-rose-50 dark:hover:bg-rose-500/10 transition-colors duration-200"
                >
                    <FontAwesomeIcon icon={faTrash} className="text-[12px]" />
                </button>
            </div>

            <div className="mt-4 grid grid-cols-1 gap-5 smallTablet:gap-4">
                <CustomInput
                    autoComplete="none"
                    label="Full name"
                    placeholder="Full name"
                    defaultValue={driver?.name}
                    name='name'
                    onChange={HandleChangeDriverValues}
                />
                <CustomSelect
                    comboboxType="select"
                    options={providerPermissionFields}
                    placeholder="Select items"
                    labelProperty="label"
                    valueProperty="id"
                    label="Chase items"
                    onMultiSelectChange={(option: typeof providerPermissionFields) => setDriverChaseItems([...option])}
                    value={driverchaseItems}
                    multiple
                />
            </div>
        </div>
    )
}

export default DriverForm
